import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Zap, MessageSquare, Cloud } from "lucide-react";

const ChatBotSelection = () => {
  const navigate = useNavigate();

  const aiServices = [
    {
      id: "Perplexity",
      name: "Perplexity",
      description:
        "Your private research companion. Get real-time answers with verified sources — securely, without leaving a trace.",
      icon: <Zap size={40} color="#fff" />,
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    },
    {
      id: "chatgpt",
      name: "ChatGPT",
      description:
        "Your creative partner. Brainstorm, write, analyze, and explore ideas with advanced conversational AI — always in your private environment.",
      icon: <MessageSquare size={40} color="#fff" />,
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    },
    {
      id: "bedrock",
      name: "Bedrock",
      description:
        "Your enterprise-grade problem solver. Access powerful foundation models for deeper analysis and complex tasks, with maximum privacy controls.",
      icon: <Cloud size={40} color="#fff" />,
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
    },
  ];

  const handleServiceClick = (service) => {
    navigate("/chat", { state: { selectedService: service.name } });
  };

  return (
    <>
      <div className="selection-container position-relative">
        <Container>
          <div className="selection-header">
            <h1 className="selection-title">
              Choose Your Private AI Assistant
            </h1>
            <p className="selection-subtitle">
              Access your secure, personal AI tools — all in one place. Every
              interaction is encrypted, private, and designed for your use only.
            </p>
          </div>

          <Row className="g-4 justify-content-center">
            {aiServices.map((service) => (
              <Col key={service.id} md={6} lg={4}>
                <div
                  className="ai-card h-100"
                  onClick={() => handleServiceClick(service)}
                >
                  <div
                    className="ai-icon"
                    style={{ background: service.gradient }}
                  >
                    {service.icon}
                  </div>
                  <h3 className="ai-title">{service.name}</h3>
                  <p className="ai-description">{service.description}</p>

                  <Button
                    variant="outline-light"
                    className="mt-3"
                    style={{
                      borderRadius: "25px",
                      padding: "8px 24px",
                      borderColor: "rgba(255, 255, 255, 0.3)",
                      transition: "all 0.3s ease",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleServiceClick(service);
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = service.gradient;
                      e.currentTarget.style.borderColor = "transparent";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "transparent";
                      e.currentTarget.style.borderColor =
                        "rgba(255, 255, 255, 0.3)";
                    }}
                  >
                    Start
                  </Button>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ChatBotSelection;
